import { LoadingButton } from "@mui/lab";
import React, { useState } from "react";
import { Employee } from "../../models/organisation/OrganisationModelV2";
import { EmployeeSettingsModal } from "./EmployeeSettingModal";
import { useMutation } from "@apollo/client";
import { showErrorMessage } from "../../helper/helper";
import { client } from "../..";
import { UpdateEmployeePermissions } from "../../api/orgs";

type Props = {
    employee: Employee
    orgId: number
    dbRefetch?: any
}

export const EmployeeSettingsButton: React.FC<Props> = ({ employee, orgId, dbRefetch }: Props) => {

    const [open, setOpen] = useState(false)


    const [changePermission, { loading, error }] = useMutation(
        UpdateEmployeePermissions,
        {
            client: client,
            onCompleted: () => {
                dbRefetch?.();
            },
            onError: (e) => {
                showErrorMessage(e)
            }
        }
    );


    const onDismiss = (role: string, data: any) => {
        if (role === 'save') {
            changePermission({
                variables: {
                    input: {
                        person_id: employee.personId(),
                        organisation_id: orgId,
                        bid_read: data.bid_permission,
                        bid_write: data.bid_permission
                    }
                }
            })
        }
        setOpen(false)
    }

    return (
        <>
            <LoadingButton variant="contained" loading={loading} onClick={() => setOpen(!open)}>
                Setting
            </LoadingButton>
            <EmployeeSettingsModal open={open} setOpen={setOpen} employee={employee} onDismiss={onDismiss} />
        </>
    );
}